export default __webpack_public_path__ + "static/commercial-ampm@1x-547ce72da68510f6dcfac84bd0947df1.webp";